var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('router-link',{staticStyle:{"margin-bottom":"1px"},attrs:{"tag":"li","to":"/lk/tutor-selection"}},[_c('a',{attrs:{"href":"/lk/tutor-selection"}},[_c('icon-attestation',{attrs:{"fill":"#fff"}}),_vm._v(" Отбор в тренеры ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }